import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity';
import { createReducer, on, Action } from '@ngrx/store';

import * as ReferralsActions from './referrals.actions';
import {
  Referral,
  ReferralRequestParams,
} from '@fantaz/shared/data-access/models';

export const REFERRALS_FEATURE_KEY = 'referrals';

export interface ReferralsState extends EntityState<Referral> {
  pagination?: ReferralRequestParams;
  selectedId?: string | number; // which Referrals record has been selected
  loaded: boolean; // has the Referrals list been loaded
  error?: string | null; // last known error (if any)
  total: number;
  summaries: {
    commissions: number;
  };
}

export interface ReferralsPartialState {
  readonly [REFERRALS_FEATURE_KEY]: ReferralsState;
}

export const referralsAdapter: EntityAdapter<Referral> =
  createEntityAdapter<Referral>({
    selectId: (referral: Referral) => referral.uuid,
  });

export const initialState: ReferralsState = referralsAdapter.getInitialState({
  // set initial required properties
  loaded: false,
  total: 0,
  summaries: {
    commissions: 0,
  },
});

const referralsReducer = createReducer(
  initialState,
  on(ReferralsActions.init, (state, { options }) => ({
    ...state,
    loaded: false,
    error: null,
    pagination: options,
  })),
  on(ReferralsActions.loadReferralsSuccess, (state, { referrals }) =>
    referralsAdapter.setAll(referrals.items, {
      ...state,
      loaded: true,
      total: referrals.total,
      summaries: referrals.summaries,
    }),
  ),
  on(ReferralsActions.loadReferralsFailure, (state, { error }) => ({
    ...state,
    error,
  })),
);

export function reducer(state: ReferralsState | undefined, action: Action) {
  return referralsReducer(state, action);
}
